import { Button, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { useState } from "react";
import { ClientStatusReferralEnum } from "@/__generated__/graphql";

const FILTER_ITEMS = [
  {
    label: "ALL",
    value: "ALL" as const,
  },
  {
    label: "PAID",
    value: ClientStatusReferralEnum.Paid,
  },
  {
    label: "PENDING",
    value: ClientStatusReferralEnum.Pending,
  },
];

interface ReferralHistoryFilterProps {
  filter: ClientStatusReferralEnum | "ALL";
  setFilter: (value: ClientStatusReferralEnum | "ALL") => void;
}

export const ReferralHistoryFilter = ({
  filter,
  setFilter,
}: ReferralHistoryFilterProps) => {
  const [openFilter, setOpenFilter] = useState(false);
  return (
    <View className="flex flex-row gap-3">
      <DropdownMenu onOpenChange={setOpenFilter}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="secondary"
            color="foreground"
            size="sm"
            children={filter}
            iconAlignment="end"
            iconName={openFilter ? "caretUp" : "caretDown"}
            iconColor="foreground"
            iconSize="sm"
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="mt-1 max-w-xs rounded-xl md:w-full">
          {FILTER_ITEMS.map((item, index) => {
            return (
              <DropdownMenuItem key={index} asChild>
                <View
                  onClick={() => {
                    setFilter(item.value);
                    setOpenFilter(false);
                  }}
                >
                  <Typography>{item.label}</Typography>
                </View>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </View>
  );
};
